import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { TwoFactorMethod } from '@/types/auth/Auth';
import type { VerificationDTO } from '@/types/auth/AuthDTOs';

export const resend2faCodeThunk = createAppAsyncThunk<
  VerificationDTO,
  { method: TwoFactorMethod },
  { rejectValue: { message: string } }
>(
  'auth/resend2faCode',
  async({ method }, { getState, extra: { authService }, rejectWithValue }) => {
    const state = getState();
    const twoFactorToken = state.auth.twoFactorToken;

    if (twoFactorToken === undefined) {
      return rejectWithValue({ message: 'Missing session token' });
    }

    try {
      return await authService.resendTwoFactorCode({ twoFactorToken, method });
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to resend 2FA code';
      return rejectWithValue({ message });
    }
  }
);
